module.exports = __webpack_public_path__ + "img/main-mob.e1728db8.jpg";